import { render, staticRenderFns } from "./AirwaySelectedSlice.vue?vue&type=template&id=5dc62094&scoped=true&"
import script from "./AirwaySelectedSlice.vue?vue&type=script&lang=js&"
export * from "./AirwaySelectedSlice.vue?vue&type=script&lang=js&"
import style0 from "./AirwaySelectedSlice.vue?vue&type=style&index=0&id=5dc62094&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc62094",
  null
  
)

export default component.exports